import { defaults } from 'lodash'

export const initialState = {
  asphaltMixes: [],
  coldBinsData: [],
  hotBinsData: [],
  labResults: [],
  plants: [],
  temperatureData: [],
  selectedPlantId: '',
  selectedAsphaltMixId: '',
}

export default defaults({}, initialState)
